import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneWorksBrigades(companyId, doneWorkId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].getDoneWorksBrigades,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
			},
		},
	)
}
function getDoneWorksBrigadePreview(companyId, doneWorkId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].getDoneWorksBrigadePreview,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				brigadeId,
			},
		},
	)
}
function getDoneWorksBrigadePopup(companyId, doneWorkId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].getDoneWorksBrigadePopup,
		{
			urlParams: {
				companyId: companyId,
				doneWorkId,
				brigadeId,
			},
		},
	)
}

function createDoneWorksBrigade(companyId, doneWorkId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].createDoneWorksBrigade, {
		urlParams: {
			companyId,
			doneWorkId,
		},
		...data,
	})
}

function getDoneWorksBrigade(companyId, doneWorkId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].getDoneWorksBrigade, {
		urlParams: {
			companyId,
			doneWorkId,
			brigadeId,
		},
	})
}

function patchDoneWorksBrigade(companyId, doneWorkId, brigadeId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].patchDoneWorksBrigade, {
		urlParams: {
			companyId,
			doneWorkId,
			brigadeId,
		},
		...data,
	})
}

function putDoneWorksBrigade(companyId, doneWorkId, brigadeId, data) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].putDoneWorksBrigade, {
		urlParams: {
			companyId,
			doneWorkId,
			brigadeId,
		},
		...data,
	})
}

function deleteDoneWorksBrigade(companyId, doneWorkId, brigadeId) {
	return dataTransferWrap(
		ModulesMap.DONE_WORKS_BRIGADE,
		dtConfig[ModulesMap.DONE_WORKS_BRIGADE].deleteDoneWorksBrigade, {
		urlParams: {
			companyId,
			doneWorkId,
			brigadeId,
		},
	})
}

export default {
	getDoneWorksBrigades,
	getDoneWorksBrigadePopup,
	getDoneWorksBrigadePreview,
	getDoneWorksBrigade,
	patchDoneWorksBrigade,
	putDoneWorksBrigade,
	createDoneWorksBrigade,
	deleteDoneWorksBrigade,
}
